import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "popup__content mb-sm",
  style: {"white-space":"pre-wrap","word-break":"break-word"}
}
const _hoisted_2 = { class: "popup__controls" }
const _hoisted_3 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    title: _ctx.$t('labels.payOutDealSla'),
    onOnClose: _ctx.hide
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.text), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
          class: "btn btn--accept"
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('button.close')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "onOnClose"]))
}